import { ActionTypes } from "../constants";

const reduceActivityTypes = (state = null, action) => {

    switch (action.type) {
        case ActionTypes.GET_ACTIVITY_TYPES_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_ACTIVITY_TYPES_FAILURE:
            return [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceActivityTypes;
